import Vue from "vue";
import Router from "vue-router";
import routeList from "./modules";
import qs from "querystring";

Vue.use(Router);

// 解决重复点击相同路由报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

let query = qs.parse(location.search.replace("?", "").replace(/\/.*/g, ""));

// 记录页面进入时间，用于计算页面停留时长
let pageEnterTime = Date.now();

const router = new Router({
  mode: "history",
  base: "/xnhdouyin/",
  routes: [
    {
      path: "/",
      name: "Index",
      beforeEnter(to, from, next) {
        if (query.page) {
          return next({
            name: query.page,
            replace: true
          });
        } else {
          next({
            name: "field1",
            replace: true
          });
        }
      }
    },
    ...routeList
  ]
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 重置页面加载开始时间（在路由跳转前记录，确保计算准确的页面加载时长）
  if (window.$amber) {
    window.$amber.resetPageStartTime();
  }

  // 上报页面停留事件（从上一个页面跳转过来时）
  if (from.name && from.path !== to.path) {
    const stayTime = Date.now() - pageEnterTime;
    if (window.$amber && stayTime > 0) {
      window.$amber.pageStay(stayTime);
    }
  }

  const searchParams = qs.parse(location.search.replace("?", ""));
  const keys = ["sdkTraceId", "entrySource", "sourceType", "sourcePlat", "channelId", "pageSeq"];

  let needUpdate = false;
  const q = { ...to.query };

  // 处理 entrySource：首次访问时，对当前页面 URL 进行 base64 编码
  if (!to.query.entrySource && !searchParams.entrySource) {
    const currentUrl = window.location.href.split("?")[0];
    q.entrySource = btoa(currentUrl);
    needUpdate = true;
  }

  // 处理 pageSeq：页面刷新不累加，页面跳转累加
  const isPageRefresh = performance.navigation && performance.navigation.type === 1;
  const currentPageSeq = parseInt(to.query.pageSeq) || 1;

  if (isPageRefresh) {
    // 页面刷新，不累加
    q.pageSeq = currentPageSeq;
  } else if (from.name && from.path !== to.path) {
    // 页面跳转，累加
    q.pageSeq = currentPageSeq + 1;
    needUpdate = true;
  } else {
    // 首次访问或无来源，设置为 1
    q.pageSeq = 1;
    if (!to.query.pageSeq) {
      needUpdate = true;
    }
  }

  keys.forEach(k => {
    if (k === "pageSeq") return; // pageSeq 已单独处理
    if (searchParams[k] && !to.query[k]) {
      q[k] = searchParams[k];
      needUpdate = true;
    }
  });

  if (needUpdate) {
    next({ path: to.path, query: q });
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  // 更新页面进入时间（用于计算页面停留时长）
  pageEnterTime = Date.now();
});

// 页面关闭或刷新时上报停留事件
window.addEventListener("beforeunload", () => {
  const stayTime = Date.now() - pageEnterTime;
  if (window.$amber && stayTime > 0) {
    window.$amber.pageStay(stayTime);
  }
});

// 页面隐藏时上报停留事件（移动端兼容）
window.addEventListener("pagehide", () => {
  const stayTime = Date.now() - pageEnterTime;
  if (window.$amber && stayTime > 0) {
    window.$amber.pageStay(stayTime);
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js